// Fotos gravadas na pasta de uploads (caminho relativo "uploads_escalador/..." ou caminho de disco antigo
// "C:/xampp/htdocs/uploads_escalador/...") são servidas pela API (rota pública uploads_escalador/ do backend).
export function urlArquivoPublico(valor, urlRest) {
  const caminho = String(valor || '').trim().replace(/\\/g, '/')
  if (!caminho) return ''
  if (/^(data:|blob:|https?:\/\/)/i.test(caminho)) return caminho
  const indice = caminho.indexOf('uploads_escalador/')
  if (indice < 0) return caminho
  try {
    return new URL(caminho.slice(indice), new URL(urlRest || '/', window.location.origin)).href
  } catch (error) {
    return caminho
  }
}
